const GENAI_CATEGORIES_HAIR = [
    { id: 'cat130038', name: 'hair' },
    { id: 'cat1910033', name: 'travelSizeHair' },
    { id: 'cat1080043', name: 'dryersHairTools' },
    { id: 'cat1200068', name: 'hairMist' },
    { id: 'cat1220035', name: 'mensHair' },
    { id: 'cat1230059', name: 'mensHairCare' },
    { id: 'cat1960037', name: 'cleanHair' },
    { id: 'cat60119', name: 'hairRemoval' }
];

const GENAI_CATEGORIES_SKINCARE = [
    { id: 'cat150006', name: 'skincare' },
    { id: 'cat1960033', name: 'cleanSkincare' },
    { id: 'cat5000015', name: 'luxurySkincare' },
    { id: 'cat1230058', name: 'mensFacialSkincare' },
    { id: 'cat1910031', name: 'travelSizeSkincare' }
];

const GENAI_CATEGORIES_FRAGRANCE = [
    { id: 'cat160006', name: 'fragrance' },
    { id: 'cat1230057', name: 'mensPerfume' },
    { id: 'cat1910032', name: 'travelSizeFragrance' },
    { id: 'cat1960031', name: 'cleanFragrance' }
];

const GENAI_CATEGORIES_MAKEUP = [
    { id: 'cat140006', name: 'makeup' },
    { id: 'cat1910030', name: 'travelSizeMakeup' },
    { id: 'cat1960035', name: 'cleanMakeup' },
    { id: 'cat5000014', name: 'luxuryMakeup' },
    { id: 'cat1210031', name: 'makeupRemover' }
];

const GENAI_TERMS_BATH_BODY = [
    'body oil',
    'hand cream',
    'body wash',
    'deodorant',
    'body butter',
    'body lotion',
    'body shimmer',
    'self tan',
    'self tanner',
    'body glow',
    'body spray',
    'body cream',
    'body',
    'exfoliating body scrub',
    'body glitter',
    'body care',
    'self body tanners',
    'body serum',
    'body sunscreen',
    'shimmer body oil',
    'body acne',
    'body wash for women',
    'body oil for women',
    'bodywash',
    'shimmer body glow',
    'body moisturizer',
    'shower oil',
    'shower gel',
    'body wash & shower gel'
];

const GENAI_TERMS_HAIR = [
    'hair',
    'hair oil',
    'shampoo',
    'conditioner',
    'hair mask',
    'dry shampoo',
    'heat protectant',
    'leave in conditioner',
    'hairspray',
    'hair treatment',
    'hair tools',
    'flat iron',
    'hair perfume',
    'curling iron',
    'hair dryers',
    'scalp treatments',
    'hair gloss',
    'hair brushes',
    'hair serum',
    'shampoo and conditioner',
    'curly hair',
    'styling products',
    'hair accessories',
    'hair gifts & value sets',
    'diffuser',
    'purple shampoo',
    'texturizing spray',
    'hair gel',
    'clarifying shampoo',
    'hair mist',
    'hair treatments',
    'curly hair care',
    'hair styling',
    'detangler',
    'comb',
    'hair masks',
    'hair loss',
    'dry scalp',
    'anti frizz',
    'head bands',
    'scalp & hair treatments',
    'hair color',
    'sea salt spray',
    'hair thinning & hair loss',
    'sulfate-free shampoo'
];

const GENAI_TERMS_FRAGRANCE = [
    'perfume',
    'cologne',
    'perfume sampler set',
    'men cologne',
    'perfume set',
    'perfume for woman',
    'mini perfume',
    'fragrance',
    'vanilla perfume',
    'perfumes',
    'hair perfume',
    'perfume sampler',
    'mini perfume set',
    'mens cologne',
    'body mist',
    'perfume mist discovery set',
    'travel perfume',
    'sampler set',
    'body spray',
    'travel size perfume',
    'clean perfume',
    'mini perfume sampler set',
    'fragrance perfume sampler set',
    'mini perfumes',
    'perfume sets',
    'perfume gift set',
    'perfume oil',
    'women perfume',
    'men cologne sampler',
    'man cologne',
    'men cologne set',
    'cologne set',
    'men cologne gift set sampler',
    'cologne sampler',
    'cologne for man',
    'fragrance set',
    'fragrance sampler',
    'clean fragrance',
    'hair mist scent'
];

const GENAI_TERMS_SKINCARE = [
    'sunscreen',
    'skincare',
    'skin care',
    'eye cream',
    'toner',
    'moisturizer',
    'face mask',
    'moisturizer for face',
    'retinol',
    'vitamin c',
    'body oil',
    'serum',
    'hand cream',
    'vitamin c serum',
    'face wash',
    'cleanser',
    'lip mask',
    'spf',
    'body wash',
    'tinted moisturizer',
    'deodorant',
    'mask',
    'best tinted moisturizer',
    'eye patches',
    'face moisturizer',
    'body butter',
    'exfoliator',
    'lotion',
    'body lotion',
    'eye mask',
    'oil cleanser',
    'face oil',
    'self tan',
    'acne',
    'cleansing balm',
    'lip scrub',
    'tinted sunscreen',
    'azelaic acid',
    'glycolic acid',
    'body scrub',
    'hyaluronic acid',
    'cleansing oil',
    'niacinamide',
    'skincare set',
    'face mist',
    'self tanner',
    'face cleanser',
    'face masks',
    'red light mask',
    'pimple patches',
    'lip balm'
];

const GENAI_TERMS_MAKEUP = [
    'concealer',
    'bronzer',
    'mascara',
    'foundation',
    'lip liner',
    'setting spray',
    'primer',
    'lip gloss',
    'skin tint',
    'highlighter',
    'contour',
    'lip',
    'setting powder',
    'lip stain',
    'makeup',
    'eyeliner',
    'lip oil',
    'eyeshadow',
    'brow gel',
    'lipstick',
    'foundation brush',
    'contour stick',
    'eyeshadow palette',
    'blush brush',
    'concealer brush',
    'eyelash curler',
    'eyebrow gel',
    'powder blush',
    'eyebrow',
    'lip tint',
    'brush set',
    'cream blush',
    'liquid blush',
    'color corrector',
    'brown mascara',
    'mascara volume',
    'pressed powder',
    'lash serum',
    'eye liner',
    'eyebrow pencil',
    'bronzer brush',
    'tubing mascara',
    'lashes',
    'eye shadow',
    'powder bronzer',
    'foundation stick',
    'cream bronzer'
];

const GENAI_TERMS_HAIR_FR = [
    'cheveux',
    'huile pour les cheveux',
    'shampoing',
    'shampooing',
    'revitalisant',
    'masque capillaire',
    'shampoing sec',
    'soin thermoprotecteur',
    'revitalisant sans rinçage',
    'fixatif',
    'soin cheveux',
    'outils cheveux',
    'fer plat',
    'parfum pour les cheveux',
    'fer à friser',
    'sèche-cheveux',
    'soins pour le cuir chevelu',
    'soin brillance',
    'brosses à cheveux',
    'sérum capillaire',
    'shampoing et revitalisant',
    'cheveux frisés',
    'produits coiffants',
    'accessoires pour cheveux',
    'cadeaux pour cheveux et ensembles-avantages',
    'diffuseur',
    'shampoing violet',
    'vaporisateur texturisant',
    'gel pour les cheveux',
    'shampoing purifiant',
    'brume cheveux',
    'soins pour les cheveux',
    'soins pour les cheveux frisés',
    'coiffure',
    'démêlant',
    'peigne',
    'masques capillaires',
    'perte de cheveux',
    'cuir chevelu sec',
    'anti-frisottis',
    'serre-têtes',
    'soins pour les cheveux et le cuir chevelu',
    'couleur des cheveux',
    'vaporisateur sel de mer',
    'cheveux minces et perte de cheveux',
    'shampoing sans sulfate'
];

const GENAI_TERMS_FRAGRANCE_FR = [
    'parfum',
    'eau de Cologne',
    'ensemble d échantillons de parfum',
    'ensemble d eaux de cologne',
    'ensemble d eaux de cologne pour hommes',
    'ensemble d échantillons',
    'ensemble d échantillons de miniparfum',
    'ensemble d échantillons de parfum',
    'ensemble-cadeau d échantillons d eau de cologne pour hommes',
    'échantillon d eau de cologne',
    'échantillon d eau de cologne pour hommes',
    'eau de Cologne pour hommes',
    'ensemble de parfum',
    'parfum pour femme',
    'miniparfum',
    'parfum',
    'parfum à la vanille',
    'parfums',
    'parfum pour les cheveux',
    'échantillon de parfum',
    'ensemble de miniparfums',
    'eau de Cologne pour hommes',
    'brume pour le corps',
    'ensemble découverte de brumes parfumées',
    'parfum de voyage',
    'ensemble d échantillons',
    'vaporisateur pour le corps',
    'parfum de format voyage',
    'parfum pur et sain',
    'ensemble d échantillons de miniparfum',
    'ensemble d échantillons de parfum',
    'miniparfums',
    'ensembles de parfums',
    'ensemble-cadeau de parfums',
    'huile parfumée',
    'parfum pour femmes',
    'échantillon d eau de Cologne pour hommes',
    'eau de Cologne pour homme',
    'ensemble d eaux de Cologne pour hommes',
    'ensemble d eaux de Cologne',
    'ensemble-cadeau d échantillons d eau de Cologne pour hommes',
    'échantillon d eau de Cologne',
    'eau de Cologne pour homme',
    'ensemble de parfums',
    'échantillon de parfum',
    'parfums purs et sains',
    'brume parfumée pour cheveux'
];

const GENAI_TERMS_SKINCARE_FR = [
    'écrans solaires',
    'soins pour la peau',
    'crème contour des yeux',
    'lotion tonique',
    'hydratant',
    'masque visage',
    'hydratant pour le visage',
    'rétinol',
    'vitamine C',
    'huile pour le corps',
    'sérum',
    'crème pour les mains',
    'sérum à la vitamine C',
    'nettoyant visage',
    'nettoyant',
    'masque pour les lèvres',
    'écran solaire',
    'nettoyant pour le corps',
    'hydratant teinté',
    'déodorant',
    'masque',
    'meilleur hydratant teinté',
    'timbres dessous des yeux',
    'hydratant pour le visage',
    'beurre pour le corps',
    'exfoliant',
    'lotion',
    'lotion pour le corps',
    'masque pour les yeux',
    'nettoyant à l huile',
    'huile visage',
    'autobronzant',
    'acné',
    'baume nettoyant',
    'exfoliant pour les lèvres',
    'écran solaire teinté',
    'acide nonanedioïque',
    'acide glycolique',
    'exfoliant pour le corps',
    'acide hyaluronique',
    'huile nettoyante',
    'niacinamide',
    'ensemble de soins pour la peau',
    'brume visage',
    'autobronzant',
    'nettoyant visage',
    'masques visage',
    'masque à lumière rouge',
    'timbres pour les boutons',
    'baume à lèvres',
    'nettoyant à l’huile',
    'sérum à la vitamine C',
    'serum a la vitamine c',
    'vitamine C'
];

const GENAI_TERMS_MAKEUP_FR = [
    'anticernes',
    'poudre bronzante',
    'mascara',
    'fond de teint',
    'ligneur pour les lèvres',
    'vaporisateur fixateur',
    'base',
    'brillant à lèvres',
    'fluide teinté',
    'illuminateur',
    'fard contour',
    'lèvres',
    'poudre fixatrice',
    'encre pour les lèvres',
    'maquillage',
    'ligneur',
    'huile pour les lèvres',
    'fard à paupières',
    'gel à sourcils',
    'rouge à lèvres',
    'pinceau fond de teint',
    'bâton contour',
    'palette de fards à paupières',
    'pinceau fard à joues',
    'pinceau anticernes',
    'recourbe-cils',
    'gel à sourcils',
    'fard à joues en poudre',
    'sourcils',
    'teinte pour les lèvres',
    'ensemble de pinceaux',
    'fard à joues crème',
    'fard à joues liquide',
    'couleur correctrice',
    'mascara brun',
    'mascara volume',
    'poudre pressée',
    'sérum pour les cils',
    'ligneur',
    'crayon à sourcils',
    'pinceau poudre bronzante',
    'mascara tube',
    'cils',
    'fard à paupières',
    'poudre bronzante',
    'fond de teint en bâton',
    'crème bronzante',
    'Choisir une option',
    'Clavarder avec Sephora'
];

const GENAI_TERMS_BATH_BODY_FR = [
    'huile pour le corps',
    'crème pour les mains',
    'gel douche',
    'déodorant',
    'beurre corporel',
    'lotion pour le corps',
    'autobronzant',
    'éclat corporel',
    'vaporisateur corporel',
    'crème pour le corps',
    'brillant pour le corps',
    'corps',
    'gommage exfoliant pour le corps',
    'paillettes pour le corps',
    'soin du corps',
    'autobronzants pour le corps',
    'sérum pour le corps',
    'écran solaire pour le corps',
    'huile scintillante pour le corps',
    'acné corporelle',
    'gel douche pour femmes',
    'huile corporelle pour femmes',
    'éclat corporel scintillant',
    'hydratant pour le corps',
    'huile de douche',
    'gel douche et nettoyant pour le corps',
    'huile chatoyante pour le corps',
    'illuminateur chatoyant pour le corps',
    'illuminateur pour le corps',
    'nettoyant corporel pour femmes',
    'poudre chatoyante pour le corps',
    'soins pour le corps'
];

const GENAI_CATEGORIES_TOOLS_AND_BRUSHES = [{ id: 'cat130042', name: 'toolsAndBrushes' }];

const GENAI_CATEGORIES_BATH_AND_BODY = [{ id: 'cat140014', name: 'bathAndBody' }];

const GENAI_CATEGORIES_GIFT = [{ id: 'cat60270', name: 'gifts' }];

export default {
    GENAI_CATEGORIES_HAIR,
    GENAI_CATEGORIES_SKINCARE,
    GENAI_CATEGORIES_FRAGRANCE,
    GENAI_CATEGORIES_MAKEUP,
    GENAI_CATEGORIES_TOOLS_AND_BRUSHES,
    GENAI_CATEGORIES_BATH_AND_BODY,
    GENAI_CATEGORIES_GIFT,
    GENAI_TERMS_BATH_BODY,
    GENAI_TERMS_HAIR,
    GENAI_TERMS_FRAGRANCE,
    GENAI_TERMS_SKINCARE,
    GENAI_TERMS_MAKEUP,
    GENAI_TERMS_HAIR_FR,
    GENAI_TERMS_FRAGRANCE_FR,
    GENAI_TERMS_SKINCARE_FR,
    GENAI_TERMS_MAKEUP_FR,
    GENAI_TERMS_BATH_BODY_FR
};
